export const frAreas = {
    'areas.list.pageTitle': 'Zones',

    'areas.list.sectionTitle': 'Zones',
    'areas.list.emptyLabel': 'Aucune zone pour le moment.',
    'areas.list.actions.addGroup': 'Ajouter une zone',
    'areas.list.actions.importExcel': 'Import Excel',
    'areas.list.actions.exportExcel': 'Export Excel',
    'areas.list.item.floatingLabelTitle': 'Nom',
    'areas.list.item.floatingLabelCode': 'Code',
    'areas.list.item.floatingLabelPath': 'Chemin',
    'areas.list.item.floatingLabelParentName': 'Pays parent',

    // AREAS >> DETAILS

    'areas.details.pageTitle': 'Détails zone',

    'areas.details.detailsInfo':
        'Pas de secteur enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Secteurs » où vous pourrez affecter des zones parentes.',
    'areas.details.actions.save': 'Enregistrer',
    'areas.details.actions.removeZone': 'Supprimer la zone',
    'areas.details.actions.disabledRemoveInfo':
        'Cette zone contient des secteurs et ne peut être supprimée.',
    'areas.details.actions.previous': 'Zones',
    'areas.details.dialog.title': 'Suppression de zone',
    'areas.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette zone ?',
    'areas.details.dialog.validateLabel': 'Supprimer',
    'areas.details.dialog.cancelLabel': 'Annuler',
    'areas.details.input.name': 'Saisissez ici le nom de la Zone *',
    'areas.details.input.code': 'Saisissez ici le code de la Zone *',
    'areas.details.input.floatingLabelName': 'Nom',
    'areas.details.input.floatingLabelCode': 'Code',
    'areas.details.item.floatingLabelTitle': 'Nom',
    'areas.details.item.floatingLabelCode': 'Code',

    // AREAS >> CREATE

    'areas.create.pageTitle': 'Création zone',

    'areas.details.sectionTitle': 'LISTE SECTEURS ENFANTS',
    'areas.create.createInfo':
        'Pas de secteur enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Secteurs » où vous pourrez affecter des zones parentes.',
    'areas.create.actions.cancelCreation': 'Annuler la création',
    'areas.create.actions.addTheArea': 'Enregistrer',
    'areas.create.input.name': 'Saisissez ici le nom de la Zone *',
    'areas.create.input.code': 'Saisissez ici le code de la Zone *',
    'areas.create.input.floatingLabelName': 'Nom',
    'areas.create.input.floatingLabelCode': 'Code',

    // AREAS >> PARENT GROUP MODEL (COUNTRY for(Midas, Irritalk, GuyHoquet), TYPE for Boogle)

    'areas.create.select.title': 'Pays parent',
    'areas.create.select.label': 'Pays parent',
    'areas.create.select.placeholder': 'Sélectionnez un pays parent',
    'areas.create.select.listTitle': 'Choix du pays parent',
    'areas.create.select.listInputLabel': 'Chercher un pays',
    'areas.create.select.listCloseLabel': 'Fermer',

    'areas.import.success': 'Bravo! Zones importés avec succès',
};
